import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface PermissionGuardProps {
  permission: 'can_assign_trfers' | 'can_edit_handoff_config' | 'can_review_applications';
  children: React.ReactNode;
}

export function PermissionGuard({ permission, children }: PermissionGuardProps) {
  const { user } = useAuth();
  if (!user?.permissions?.[permission]) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
